import { Alert, Box, Button, Divider, Flex, Grid, GridItem, Heading, SimpleGrid, Spacer, Text, AspectRatio, Image, Show, Circle, HStack } from "@chakra-ui/react";
import { Steps, Step } from "chakra-ui-steps";
import Number from "components/number-format";
import moment from "moment";
import { FC, ReactElement, useState, useEffect } from "react";
import OrderService from "services/orders/order-service";
import TimerCountdown from "../../components/timer-countdown";
import AppConsts from "../../libs/appconst";
import PayProgram from "./pay-program";
import PixelUtil from "utils/pixel-utils";

interface PayDetailSceneProps {
    order: any;
};

const PaidScene: FC<PayDetailSceneProps> = ({ order }): ReactElement => {
    useEffect(() => {
        PixelUtil.TrackPurchased(order.amount, order.invoiceNo);
    }, []);

    const handleAccessProgram = () => {
        window.open(`${AppConsts.Logos_APPURL}/programs/${order.program.id}`, "_blank");
    }

    return (
        <Box p={{ base: 2, md: 6 }} mt={6} textAlign={"center"}>
            <Alert status='success' rounded={'lg'} p={{ base: 4, md: 6 }} pl={{ base: 4, md: 12 }} textAlign={"center"}>
                <Spacer></Spacer>
                <Text fontSize={{ base: 'lg', md: "3xl" }} fontWeight={'extrabold'} textAlign={"center"}>
                    Pembayaran Anda sudah berhasil...
                </Text>
                <Spacer></Spacer>
            </Alert>

            <Box mt={{ base: 6, md: 12 }}>
                <Text fontSize={{ base: 'md', md: "lg" }} textAlign={"center"}>
                    Selamat {order.user.firstName} sudah bisa akses
                    <Text fontSize={{ base: 'md', md: "md" }} fontWeight={'bold'}>{order.program.name}</Text>
                </Text>
            </Box>

            <Divider my={4} />

            <Flex mt={4}>
                <Show above={'md'}>
                    <Spacer></Spacer>
                </Show>
                <AspectRatio maxW='600px' ratio={16 / 9} flex={"1 1 auto"}>
                    <Box borderRadius={"md"}>
                        <Image src={order.program.posterUrl} objectFit={"cover"} />
                    </Box>
                </AspectRatio>
                <Show above={'md'}>
                    <Spacer></Spacer>
                </Show>
            </Flex>

            <Divider my={6} />


            <Flex>
                <Spacer></Spacer>
                <Box>
                    <Text fontSize={{ base: 'sm', md: "md" }} fontWeight={'bold'} textAlign={"left"}>Cara Akses ke Programnya:</Text>
                    <Box mt={6}>
                        <HStack spacing={4} align="start" w="full">
                            <Circle size="24px" bg="blue.500" color="white" flexShrink={0}>
                                <Text fontSize="xs" fontWeight="bold">
                                    1
                                </Text>
                            </Circle>
                            <Flex direction="column" align="flex-start">
                                <Text fontWeight={'semibold'}>Step 1: Informasi Username dan Password.</Text>
                            </Flex>
                        </HStack>

                        <Box fontSize={'sm'} textAlign={'left'} mb={6} ml={10}>
                            <Text mt={2}>Informasi Username dan Password Anda telah dikirim ke Email atau Whatsapp yang Anda Daftarkan.</Text>
                            <Text mt={1}>Kalau belum menemukan, silahkan cek Whatsapp atau Email di folder Spam / Promosi.</Text>
                        </Box>

                        <Box fontSize={'sm'} textAlign={'left'} mb={6} ml={10} p={4} backgroundColor={'yellow.100'} rounded={"lg"} border={"solid"} borderWidth={1} borderColor={'red'}>
                            <HStack>
                                <Text>Email Anda: </Text>
                                <Text fontWeight={"bold"}>{order.user.emailAddress}</Text>
                            </HStack>
                            <HStack mt={2}>
                                <Text>Whatsapp Anda: </Text>
                                <Text fontWeight={"bold"}>{order.user.phoneNumber}</Text>
                            </HStack>
                        </Box>
                    </Box>

                    <Box>
                        <HStack spacing={4} align="start" w="full">
                            <Circle size="24px" bg="blue.500" color="white" flexShrink={0}>
                                <Text fontSize="xs" fontWeight="bold">
                                    2
                                </Text>
                            </Circle>
                            <Flex direction="column" align="flex-start">
                                <Text fontWeight={'semibold'}>Step 2: Akses Member Area.</Text>
                            </Flex>
                        </HStack>

                        <Box fontSize={'sm'} textAlign={'left'} mb={6} ml={10}>
                            <Text mt={2}>Klik Tombol dibawah ini untuk Login dan Akses ke Programnya</Text>
                            <Button fontSize={"md"} mt={3} py={6} px={6} onClick={handleAccessProgram}> Akses Program di Member Area </Button>
                        </Box>
                    </Box>
                </Box>
                <Spacer></Spacer>
            </Flex>

            <Divider my={12} />

            <Text mt={12} fontSize={{ base: 'sm', md: "md" }} textAlign={"center"}>Butuh Bantuan?</Text>
            <Flex mt={1} mb={12}>
                <Spacer />
                <Button variant={"outline"} onClick={() => { window.open(AppConsts.UrlSupportTeam, "_blank") }}>Hubungi Team Support</Button>
                <Spacer />
            </Flex>
        </Box >
    );
};

export default PaidScene;